module.exports = {
  THEME_SYSTEM: 'system',
  THEME_LIGHT: 'light',
  THEME_DARK: 'dark',
};
